import React, { useState } from 'react'
import logo from './../../assets/logo doe.jpg'
import './login.css'
import { FacebookOutlined, Instagram, LockOutlined, PersonOutline, Twitter, WhatsApp } from '@mui/icons-material'
import NdoeSpinner from '../../components/ndoe/NdoeSpinner';
import { useDispatch, useSelector } from 'react-redux'
import { login } from '../../redux/apiCalls'
import { useNavigate } from 'react-router-dom'
import Swal from 'sweetalert2'
import { message } from 'antd';

const Login1 = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { isFetching, error } = useSelector((state) => state.user);

  const handleClick = async (e) => {
    e.preventDefault();
  
    try {
      setIsLoading(true);
      await login(dispatch, { username, password },navigate);

    } catch (error) {
      console.log(error);

    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
    <div className="container">
      <div className="forms-container">
        <div className="signin-signup">
          <form action="#" className="sign-in-form">
            <h2 className="title">Se connecter</h2>
            <div className="input-field">
              <PersonOutline className='icon-login'/>
              <input type="email" placeholder="E-mail" aria-label="E-mail" onChange={(e) => setUsername(e.target.value)} />
            </div>
            <div className="input-field">
                <LockOutlined className='icon-login'/>
              <input type="password" placeholder="Password" onChange={(e) => setPassword(e.target.value)} />
            </div>
            <input type="submit" value="Se connecter" className="btn solid" onClick={handleClick} />
            <p className="social-text">Connectez-vous avec les plateformes sociales</p>
            <div className="social-media">
              <a href="#" className="social-icon">
                <FacebookOutlined />
              </a>
              <a href="#" className="social-icon">
                <Twitter />
              </a>
              <a href="#" className="social-icon">
                <WhatsApp />
              </a>
              <a href="#" className="social-icon">
                <Instagram />
              </a>
            </div>
          </form>
        </div>
      </div>

      <div className="panels-container">
        <div className="panel left-panel">
          <div className="content">
            <h3>Voulez-vous créer un compte ?</h3>
            <button className="btn transparent" id="sign-up-btn" onClick={()=>navigate('/register')}>
                S'inscrire
            </button>
            <button className="btn transparent" id="sign-up-btn" onClick={()=>navigate('/forgot')}>
                Mot de passe oublié
            </button>
            {isLoading && (
              <div className="loader-container loader-container-center">
                <NdoeSpinner size={24} />
              </div>
            )}
          </div>
          <img src={logo} className="image" alt="" />
        </div>
      </div>
    </div>

    </>
  )
}

export default Login1